import { render } from "./TheBody.vue?vue&type=template&id=2b7948f2&scoped=true"
import script from "./TheBody.vue?vue&type=script&lang=js"
export * from "./TheBody.vue?vue&type=script&lang=js"

import "./TheBody.vue?vue&type=style&index=0&id=2b7948f2&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7948f2"]])

export default __exports__